export const generateCSSFilterForBorder = ({
  color = '#fff',
  borderSize = 1,
}: {
  color?: string;
  borderSize?: number;
} = {}): string => `
      drop-shadow(-${borderSize}px -${borderSize}px 0px ${color})
      drop-shadow(${borderSize}px -${borderSize}px 0px ${color})
      drop-shadow(${borderSize}px ${borderSize}px 0px ${color})
      drop-shadow(-${borderSize}px ${borderSize}px 0px ${color})
  `;
